import { useState } from "react";

function OptionsAnalysisMasterclassModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Advanced Understanding of Options Markets",
      content: [
        "Deep dive into the options market structure.",
        "Understanding open interest, volume, and their significance in trading decisions.",
        "Analyzing option chain data for informed trading.",
        "Role of market makers and impact on option pricing.",
      ],
    },
    {
      title: "Module 2: Mastering Options Pricing Models",
      content: [
        "Detailed exploration of the Black-Scholes Model and its limitations.",
        "Introduction to Binomial and Trinomial Models.",
        "How to use options pricing models for real-time trading.",
        "Case study: Applying pricing models in different market conditions.",
      ],
    },
    {
      title: "Module 3: The Greeks: Advanced Applications",
      content: [
        "Beyond basics: Understanding second-order Greeks (Gamma, Vanna, Vomma).",
        "Using Delta hedging to protect your portfolio.",
        "Advanced Theta decay management for time-sensitive strategies.",
        "Practical examples of Vega and Rho analysis in high volatility environments.",
      ],
    },
    {
      title: "Module 4: Volatility Analysis and Trading",
      content: [
        "Understanding historical vs. implied volatility.",
        "Analyzing the Volatility Smile and Volatility Skew.",
        "Using the VIX (Volatility Index) to forecast market movements.",
        "Strategies for trading volatility: Straddles, Strangles, and Calendar Spreads.",
      ],
    },
    {
      title: "Module 5: Options Flow and Unusual Activity Analysis",
      content: [
        "Decoding unusual options activity for hidden market signals.",
        "Tools and techniques for tracking big money trades.",
        "How to identify institutional buying and selling through options flow.",
        "Case study: Analyzing options flow to predict stock movements.",
      ],
    },
    {
      title: "Module 6: Advanced Options Strategies",
      content: [
        "Iron Condor Adjustments: Managing iron condors through market fluctuations.",
        "Double Diagonals and Broken Wing Butterflies: Complex spreads for advanced traders.",
        "Reverse Iron Condor: Leveraging volatility without directional bias.",
        "Ratio Backspread: A high-reward strategy for significant price moves.",
      ],
    },
    {
      title: "Module 7: Earnings and Event-Driven Options Trading",
      content: [
        "Building strategies around earnings announcements and other key events.",
        "Pre-earnings Volatility Play: Capitalizing on implied volatility rise.",
        "Post-earnings IV Crush: Strategies for rapid IV drop.",
        "Real-world examples of event-driven options trades.",
      ],
    },
    {
      title: "Module 8: Risk Management and Position Sizing",
      content: [
        "Advanced techniques for mitigating risk in options trading.",
        "Using Delta Neutral strategies to hedge your portfolio.",
        "Portfolio Margining: How to leverage margin for options trading.",
        "Managing drawdowns and protecting your capital.",
      ],
    },
    {
      title: "Module 9: Options Arbitrage Opportunities",
      content: [
        "Understanding different types of arbitrage (Risk Arbitrage, Conversion, and Reversal).",
        "Identifying arbitrage opportunities in live markets.",
        "Strategies for exploiting mispricings between option contracts.",
        "Practical examples of arbitrage in volatile markets.",
      ],
    },
    {
      title: "Module 10: Options Scanning and Analysis Tools",
      content: [
        "Overview of professional options analysis tools (e.g., Thinkorswim, Sensibull, OptionNet Explorer).",
        "How to set up custom scanners for finding high-probability trades.",
        "Using backtesting software to refine your strategies.",
        "Leveraging AI and machine learning for predictive options analysis.",
      ],
    },
    {
      title: "Module 11: Live Trading and Case Studies",
      content: [
        "Real-time options analysis and trading demonstration.",
        "Case studies of successful options trades, including entry, adjustment, and exit.",
        "Interactive Q&A session with live market analysis.",
        "How to develop a trading plan and stick to it in real-world scenarios.",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Options Analysis Masterclass Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #ddd",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: "1px solid #ddd",
                    borderTop: "none",
                    backgroundColor: "#ffffff",
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "8px",
                        backgroundColor: "#fdfdfd",
                      }}
                    >
                      <span style={{ color: "#007bff", marginRight: "8px" }}>➤</span>
                      <p className="m-0" style={{ fontSize: "14px", color: "#333" }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OptionsAnalysisMasterclassModule;
